module.exports = __webpack_public_path__ + "media/damages/car-rr-c96aa977.png";